import React from 'react';
import { Target } from 'lucide-react';

import { IdeationCard } from '../IdeationCard';
import { SuggestedChannelCard } from '../SuggestedChannelCard';
import type { HowToRespondProps } from './HowToRespond.types';
import { useTranslation } from 'react-i18next';

export const HowToRespond = ({
  ideas,
  executions,
  opportunityTypeImpact,
}: HowToRespondProps): React.JSX.Element => {
  const { t } = useTranslation('analysis');

  const hasIdeas = ideas && ideas.length > 0;
  const hasExecutions = executions && executions.length > 0;

  if (!hasIdeas && !hasExecutions) {
    return <></>;
  }

  return (
    <div className="grid grid-cols-1 gap-4 mt-12">
      <div className="flex gap-4 items-center">
        <div className="w-14 h-14 flex items-center justify-center bg-surface dark:bg-surface-raised rounded-md">
          <Target size={22} />
        </div>
        <p className="text-foreground text-2xl font-medium">
          {t('socialMediaOpportunitiesWidget.howToRespond.howToRespond')}
        </p>
      </div>

      {opportunityTypeImpact && (
        <div className="full-w border border-border-light rounded-lg p-6 grid grid-cols-2">
          <p className="text-base text-foreground font-medium">
            {t('socialMediaOpportunitiesWidget.howToRespond.message')}
          </p>
          <p className="text-base text-foreground-alt">{opportunityTypeImpact}</p>
        </div>
      )}

      {hasIdeas && (
        <div className="grid grid-cols-1 gap-4">
          <div className="flex gap-2">
            <p className="text-base text-foreground font-medium">
              {t('socialMediaOpportunitiesWidget.howToRespond.thoughtStarters')}
            </p>
            <p className="text-base text-foreground-alt">
              {'  '}•{'  '}
            </p>

            <p className="text-base text-foreground-alt">
              {t('socialMediaOpportunitiesWidget.howToRespond.suggestedByIdeationTool')}
            </p>
          </div>
          <div className="grid grid-cols-2 gap-4">
            {ideas.map((idea, index) => (
              <IdeationCard key={index} index={index} idea={idea} />
            ))}
          </div>
        </div>
      )}

      {hasExecutions && (
        <div className="grid grid-cols-1 gap-4 mt-2">
          <div>
            <p className="font-medium text-foreground text-base">
              {t('socialMediaOpportunitiesWidget.howToRespond.suggestedChannels')}
            </p>
          </div>
          <div className="grid grid-cols-1 gap-4">
            {executions.map((execution, index) => (
              <SuggestedChannelCard key={index} execution={execution} />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
